import { createFileRoute } from '@tanstack/react-router';

import { ErrorComponent } from '@/components/common/ErrorComponent';
import { useSetBreadcrumbs } from '@/components/layout/breadcrumbs';

import { IntegrationsPage } from './-components/IntegrationsPage';

function IntegrationsRoute() {
  useSetBreadcrumbs([{ label: 'Settings' }, { label: 'Integrations' }]);
  return <IntegrationsPage />;
}

export const Route = createFileRoute('/settings/integrations')({
  component: IntegrationsRoute,
  errorComponent: ErrorComponent,
});
